import { AxiosResponse } from 'axios';
import axiosInstance, { BASE_URL } from './axios';

export const getProjectTypes = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/project_types');
    return response.data;
  } catch (error) {
    throw new Error(`Error fetching project types: ${error}`);
  }
};

export const getProjectTypeById = async (id: string): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get(`/project_types/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(`Error fetching project type by id: ${error}`);
  }
};

export const createProjectType = async (data: FormData): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post(`/project_types`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'internal service error';
    throw new Error(`Error creating the project type: ${errorMessage}`);
  }
};

export const updateProjectType = async (id: number, data: FormData): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.patch(`/project_types/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'internal service error';
    throw new Error(`Error updating the project type: ${errorMessage}`);
  }
};

export const getProjectTypeGroups = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/project_groups');
    return response.data;
  } catch (error) {
    throw new Error(`Error fetching project type groups: ${error}`);
  }
};

export const getProjectTypeGroupById = async (id: string): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get(`/project_groups/${id}`);
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching project type group by id: ${errorMessage}`);
  }
};

export const createProjectTypeGroup = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post(`/project_groups`, data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'internal service error';
    throw new Error(`Error creating the project type group: ${errorMessage}`);
  }
};

export const updateProjectTypeGroup = async (id: number, data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.patch(`/project_groups/${id}`, data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'internal service error';
    throw new Error(`Error updating the project type group: ${errorMessage}`);
  }
};

export const getRegistryMappings = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/project_types/registry_mapping');
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching registry mappings: ${errorMessage}`);
  }
};

export const createRegistryMapping = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post('/project_types/registry_mapping', data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error creating registry mapping: ${errorMessage}`);
  }
};

export const getProjectIdProjectTypeMappings = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get(
      '/project_types/project_id_project_type_mapping',
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching project ID project type mappings: ${errorMessage}`);
  }
};

export const createProjectIdProjectTypeMapping = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post(
      '/project_types/project_id_project_type_mapping',
      data,
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error creating project ID project type mapping: ${errorMessage}`);
  }
};

export const getGenericMappings = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/project_types/generic_mapping');
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching generic mappings: ${errorMessage}`);
  }
};

export const createGenericMapping = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post('/project_types/generic_mapping', data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error creating generic mapping: ${errorMessage}`);
  }
};

export const updateGenericMapping = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.put('/project_types/generic_mapping', data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error updating generic mapping: ${errorMessage}`);
  }
};

export const deleteGenericMapping = async (id: string): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.delete(`/project_types/generic_mapping/${id}`);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error deleting generic mapping: ${errorMessage}`);
  }
};

export const getGenericProjectIdMappings = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/project_types/generic_project_id_mapping');
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching generic project ID mappings: ${errorMessage}`);
  }
};

export const createGenericProjectIdMapping = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post('/project_types/generic_project_id_mapping', data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error creating generic project ID mapping: ${errorMessage}`);
  }
};

export const updateProjectAttributeChangeLogActionTaken = async (
  id: string,
  action_taken: boolean,
): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.patch(
      `/project_types/project_attribute_change_log/${id}`,
      { action_taken },
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error updating action taken: ${errorMessage}`);
  }
};

export const getProjectAttributeChangeLogs = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/project_types/project_attribute_change_log');
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching project attribute change logs: ${errorMessage}`);
  }
};

export const getMarketIndicatorMappings = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/market_indicators/mapping');
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching market indicator mappings: ${errorMessage}`);
  }
};

export const createMarketIndicatorMapping = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post('/market_indicators/mapping', data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error creating market indicator mapping: ${errorMessage}`);
  }
};

export const updateMarketIndicatorMapping = async (id: string, data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.put(`/market_indicators/mapping/${id}`, data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error updating market indicator mapping: ${errorMessage}`);
  }
};

export const deleteMarketIndicatorMapping = async (id: string): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.delete(`/market_indicators/mapping/${id}`);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error deleting market indicator mapping: ${errorMessage}`);
  }
};

export const getMarketIndicatorMethodologyVersionMappings = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.get('/market_indicators/methodology_version_mapping');
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error fetching market indicator methodology version mappings: ${errorMessage}`);
  }
};

export const createMarketIndicatorMethodologyVersionMapping = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.post('/market_indicators/methodology_version_mapping', data);
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error creating market indicator methodology version mapping: ${errorMessage}`);
  }
};

export const updateMarketIndicatorMethodologyVersionMapping = async (id: string, data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.put(
      `/market_indicators/methodology_version_mapping/${id}`,
      data,
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error updating market indicator methodology version mapping: ${errorMessage}`);
  }
};

export const deleteMarketIndicatorMethodologyVersionMapping = async (id: string): Promise<any> => {
  try {
    const response: AxiosResponse = await axiosInstance.delete(
      `/market_indicators/methodology_version_mapping/${id}`,
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 'internal service error';
    throw new Error(`Error deleting market indicator methodology version mapping: ${errorMessage}`);
  }
};

